var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-index"},[_c('div',{on:{"mouseover":_vm.stop,"mouseleave":_vm.start}},[_c('h3',{staticClass:"menber",staticStyle:{"color":"red"},attrs:{"title":_vm.tips}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('a',{staticClass:"now-in",attrs:{"href":_vm.link,"title":_vm.tips,"target":"_blank"}},[_vm._v(_vm._s(_vm.button))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60559420","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Ad_Top.vue
// module id = null
// module chunks = 